// Tutor API service
const getApiBaseUrl = () => {
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_API_BASE_URL || 'https://api.afriqcm.com';
  }
  // In development, use proxy (no origin needed)
  return '';
};

const API_BASE_URL = getApiBaseUrl();
const API_VERSION = process.env.REACT_APP_API_VERSION || 'v1';
const TUTOR_API_URL = API_BASE_URL ? `${API_BASE_URL}/${API_VERSION}/tutors` : `/${API_VERSION}/tutors`;

const handleApiResponse = async (response) => {
  const contentType = response.headers.get('content-type');
  if (!contentType || !contentType.includes('application/json')) {
    const text = await response.text();
    throw new Error(`Invalid response format: ${text}`);
  }

  const data = await response.json();
  
  if (data.status === 'success') {
    return data;
  } else {
    throw new Error(data.message || 'API error');
  }
};

const handleApiError = async (response) => {
  const contentType = response.headers.get('content-type');
  let errorData;
  
  try {
    if (contentType && contentType.includes('application/json')) {
      errorData = await response.json();
    } else {
      const text = await response.text();
      errorData = {
        status: 'error',
        message: text || `HTTP ${response.status} Error`,
        error: `HTTP ${response.status}`,
        details: []
      };
    }
  } catch (e) {
    errorData = {
      status: 'error',
      message: `HTTP ${response.status} Error`,
      error: `HTTP ${response.status}`,
      details: []
    };
  }

  // Extract field-specific errors from details array
  const fieldErrors = {};
  if (errorData.details && Array.isArray(errorData.details)) {
    errorData.details.forEach(detail => {
      if (detail.field) {
        fieldErrors[detail.field] = detail.message || detail.code || 'Invalid value';
      }
    });
  }

  return {
    message: errorData.message || errorData.error || `HTTP ${response.status} Error`,
    fieldErrors: fieldErrors,
    statusCode: response.status,
    errorData: errorData
  };
};

export const submitTutorApplication = async (applicationData) => {
  try {
    const url = `${TUTOR_API_URL}/apply`;
    console.log('Submitting tutor application to:', url);
    console.log('Application data:', applicationData);
    
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'accept': 'application/json',
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      body: JSON.stringify(applicationData),
    });

    console.log('Response status:', response.status);
    console.log('Response ok:', response.ok);

    // Handle success (201)
    if (response.status === 201) {
      const data = await handleApiResponse(response);
      console.log('Tutor application submitted successfully:', data);
      return {
        success: true,
        data: data.data,
        message: data.message || 'Application submitted successfully'
      };
    }

    // Handle errors (400, 404, 422, 500)
    const error = await handleApiError(response);
    console.error('Tutor application error:', error);
    
    return {
      success: false,
      message: error.message,
      fieldErrors: error.fieldErrors,
      statusCode: error.statusCode,
      errorData: error.errorData
    };

  } catch (error) {
    console.error('Tutor application fetch error:', error);
    
    // Handle network errors
    if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
      return {
        success: false,
        message: 'Network error: Unable to connect to the server. Please check your internet connection and try again.',
        fieldErrors: {},
        statusCode: 0
      };
    }

    return {
      success: false,
      message: error.message || 'An unexpected error occurred. Please try again later.',
      fieldErrors: {},
      statusCode: 0
    };
  }
};

